import * as Mutations from './mutations';
import { SCHOOL_APP } from '@/main';

export const TextareaModal = {
    state: {
        showTextarea: false,
        textareaInfo: null,
        textareaNote: null
    },

    mutations: {
        [Mutations.OPEN_TEXTAREA] (state, info) {
            state.showTextarea = true;
            state.textareaInfo = info
        },

        [Mutations.CLOSE_TEXTAREA] (state) {
            state.showTextarea = false;
            state.textareaInfo = null;
            state.textareaNote = null;
        },

        [Mutations.SET_TEXTAREA_NOTE] (state, note) {
            state.textareaNote = note;
        }
    },

    actions: {
        openTextarea(context, payload) {
            context.commit(Mutations.OPEN_TEXTAREA, payload);
            context.dispatch('closeModal', false);
            SCHOOL_APP.$emit('show-fade');
        },

        closeTextarea(context) {
            SCHOOL_APP.$emit('hide-fade');
            context.commit(Mutations.CLOSE_TEXTAREA);
        },

        saveTextarea(context, payload) {
            context.commit(Mutations.SET_TEXTAREA_NOTE, payload);
            const { callback, id } = context.getters.textareaInfo;
            SCHOOL_APP.$emit('hide-fade');
            if (callback) {
                callback(id);
                context.commit(Mutations.CLOSE_TEXTAREA);
            }
        }
    },

    getters: {
        showTextarea: state => state.showTextarea,

        textareaInfo: state => state.textareaInfo,

        textareaId: state => state.textareaInfo && state.textareaInfo.id,

        textareaDefaultText: state => state.textareaInfo && state.textareaInfo.text,

        textareaNote: state => state.textareaNote,
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/textarea-modal/textarea-modal.module.js